import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';

import ExamSlicReducer from './ExamSlice';
import mainTabReducer from './mainTabSlice';
import notebookReducer from './notebookSlice';
import selectedSideBarReducer from './selectedSideBar';
import selectedSubTopicReducer from './selectedSubTopicSlice';
import selectedTopicReducer from './selectedTopicSlice';
import storage from 'redux-persist/lib/storage';
import testSelectionReducer from './testSelectionSlice';
import userDetailsReducer from './userDetailsSlice';
import flashCardReducer from './flashcardSlice';
import navigationReducer from './navigationSlice';

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['userDetails', 'ExamSlice', 'testSelection', 'mainTab', 'flashcard', 'navigation'],
};

const rootReducer = combineReducers({
	notebook: notebookReducer,
	userDetails: userDetailsReducer,
	selectedSubTopic: selectedSubTopicReducer,
	selectedSideBar: selectedSideBarReducer,
	selectedTopic: selectedTopicReducer,
	mainTab: mainTabReducer,
	ExamSlice: ExamSlicReducer,
	testSelection: testSelectionReducer,
	flashcard: flashCardReducer,
	navigation: navigationReducer,
});

// const persistedUserDetailsReducer = persistReducer(persistConfig, userDetailsReducer);
const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = configureStore({
// 	reducer: {
// 		notebook: notebookReducer,
// 		userDetails: persistedUserDetailsReducer,
// 		selectedSubTopic: selectedSubTopicReducer,
// 		selectedSideBar: selectedSideBarReducer,
// 		selectedTopic: selectedTopicReducer,
// 		mainTab: mainTabReducer,
// 		ExamSlice: ExamSlicReducer,
// 		testSelection: testSelectionReducer,
// 	},
// 	middleware: (getDefaultMiddleware) =>
// 		getDefaultMiddleware({
// 			serializableCheck: {
// 				ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
// 			},
// 		}),
// });

const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
			},
		}),
});

export const persistor = persistStore(store);
export default store;
